module.exports = __webpack_public_path__ + "img/icon_3.9fd432e7.svg";